export default "skymp5-front/0de290ed67386bfdd890d6bce895d5b5.png";